/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import { HealthCheckResponse, HealthCheckResponseFromJSON, HealthCheckResponseToJSON } from "../models";

export interface HealthGetRequest {
  apiVersion?: HealthGetApiVersionEnum;
}

/**
 *
 */
export class HealthApi extends runtime.BaseAPI {
  /**
   */
  async healthGetRaw(requestParameters: HealthGetRequest): Promise<runtime.ApiResponse<HealthCheckResponse>> {
    const queryParameters: any = {};

    if (requestParameters.apiVersion !== undefined) {
      queryParameters["api-version"] = requestParameters.apiVersion;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/Health`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) => HealthCheckResponseFromJSON(jsonValue));
  }

  /**
   */
  async healthGet(requestParameters: HealthGetRequest): Promise<HealthCheckResponse> {
    const response = await this.healthGetRaw(requestParameters);
    return await response.value();
  }
}

/**
 * @export
 * @enum {string}
 */
export enum HealthGetApiVersionEnum {
  _10 = "1.0",
}
